import { render } from "./EventCard.vue?vue&type=template&id=1a5f06aa"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./EventCard.vue?vue&type=style&index=0&id=1a5f06aa&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script